export const PHONE_DISPLAY = "04 74 68 73 45";
export const PHONE_TEL = "tel:+33474687345";
export const ADDRESS = "2028 Route de Longsard, 69400 Arnas";
export const MAPS_URL = "https://www.google.com/maps?q=2028+Route+de+Longsard,+69400+Arnas";
export const MAPS_EMBED = "https://www.google.com/maps?q=2028+Route+de+Longsard,+69400+Arnas&output=embed";

export const SCHEDULE = [
  { day: "Lundi", dayIndex: 1, slots: [] },
  { day: "Mardi", dayIndex: 2, slots: [[11.5, 13.5], [18.5, 21.5]] },
  { day: "Mercredi", dayIndex: 3, slots: [[11.5, 13.5], [18.5, 21.5]] },
  { day: "Jeudi", dayIndex: 4, slots: [[11.5, 13.5], [18.5, 21.5]] },
  { day: "Vendredi", dayIndex: 5, slots: [[11.5, 13.5], [18.5, 21.5]] },
  { day: "Samedi", dayIndex: 6, slots: [[18.5, 21.5]] },
  { day: "Dimanche", dayIndex: 0, slots: [[18.5, 21.5]] },
];

export function formatSlot(h) {
  const hh = Math.floor(h);
  const mm = Math.round((h - hh) * 60);
  return `${hh}h${mm === 0 ? "00" : mm}`;
}

export function isOpenNow(date = new Date()) {
  const day = SCHEDULE.find((d) => d.dayIndex === date.getDay());
  if (!day || day.slots.length === 0) return false;
  const now = date.getHours() + date.getMinutes() / 60;
  return day.slots.some(([a, b]) => now >= a && now < b);
}

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}
